import ApiService from "@/core/services/api.service";
import i18nService from "@/core/services/i18n.service.js";

const state = {
  errors: null,
  collection: [],
};

const getters = {
  contactListCollection(state) {
    return state.collection;
  },
};

const actions = {
  fetchContactList(context) {
    return new Promise((resolve) => {
      let appLocale = i18nService.getActiveLanguage();
    
      ApiService.get("contact/all").then(({ data }) => {
        let dataFormatted = data.map((item) => {
          let contactData = item.contact_data || {};
        
          if (typeof contactData === "string") {
            try {
              contactData = JSON.parse(contactData);
            } catch (e) {
              contactData = {};
            }
          }
        
          if (!contactData) {
            contactData = {};
          }
        
          if (!item.companyType || item.companyType.translations.length == 0) {
            item.companyTypeName = "";
          } else {
            if (item.companyType.translations[appLocale]) {
              item.companyTypeName =
                item.companyType.translations[appLocale].name;
            } else {
              item.companyTypeName =
                item.companyType.translations[
                  Object.keys(item.companyType.translations)[0]
                ].name;
            }
          }
        
          if (item.model == "Contact") {
            item.companyName = item.company;
            item.contactName = item.name;
          
            let phones = [];
          
            if (contactData.phone_number) {
              phones.push(contactData.phone_number);
            }
          
            if (contactData.mobile_number) {
              phones.push(contactData.mobile_number);
            }
          
            item.phones = phones.join(" / ");
          } else {
            item.companyName = item.name;
            item.companyId = item.id;
          }
        
          item.nameArray = [];
        
          if (item.companyName) {
            item.nameArray.push(item.companyName);
          }
        
          if (item.contactName) {
            item.nameArray.push(item.contactName);
          }
        
          if (contactData.phone_number) {
            item.nameArray.push(contactData.phone_number);
          }
        
          if (contactData.mobile_number) {
            item.nameArray.push(contactData.mobile_number);
          }
        
          if (item.email) {
            item.nameArray.push(item.email);
          }
        
          if (item.companyAddresses && item.companyAddresses.billing) {
            item.billingCountries = item.companyAddresses.billing.map(
              (i) => i.country
            );
          }
        
          item.name = item.nameArray.join(" | ");
        
          return item;
        });
      
        context.commit("fetchContactList", dataFormatted);
        resolve();
      });
    });
  },
};

const mutations = {
  fetchContactList(state, data) {
    state.collection = data;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
